import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconArrowLeftRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 40 40",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M31.0625 27.5625L37.5625 21.0625C38.15 20.475 38.15 19.525 37.5625 18.9437L31.0625 12.4375C30.475 11.85 29.525 11.85 28.9437 12.4375C28.3625 13.025 28.3562 13.975 28.9437 14.5562L32.8812 18.4937H7.12495L11.0625 14.5562C11.65 13.9687 11.65 13.0187 11.0625 12.4375C10.475 11.8562 9.52495 11.85 8.9437 12.4375L2.43745 18.9375C1.84995 19.525 1.84995 20.475 2.43745 21.0562L8.93745 27.5625C9.52495 28.15 10.475 28.15 11.0562 27.5625C11.6375 26.975 11.6437 26.025 11.0562 25.4437L7.1187 21.5062H32.875L28.9375 25.4437C28.35 26.0312 28.35 26.9812 28.9375 27.5625C29.525 28.1437 30.475 28.15 31.0562 27.5625H31.0625Z",
		fill: "currentColor"
	})
});
export default SvgIconArrowLeftRight;
